// A „töltsd le a mobilappot" sáv FELÜLETE. A döntés a `lib/app-banner.ts`-ben él.
//
// Telefonos böngészőben, az app saját WebView-ján kívül jelenik meg; a
// bezárást 14 napig megjegyezzük. A süti-sávhoz hasonlóan a `<body>` alá
// kerül, hogy a képernyőváltások (`replaceChildren`) ne töröljék.

import { h } from '../lib/dom';
import { bannerTarget, rememberDismissal } from '../lib/app-banner';

export function appBannerMegjelenites(): void {
  let storage: Storage | null = null;
  try {
    storage = window.localStorage;
  } catch {
    storage = null;
  }

  const cel = bannerTarget({
    ua: navigator.userAgent,
    maxTouchPoints: navigator.maxTouchPoints,
    platform: navigator.platform,
    now: Date.now(),
    storage,
  });
  if (!cel) return;

  const gyoker = document.getElementById('root');
  let burkolat: HTMLElement;

  const doboz = h(
    'div',
    {
      class: 'card el3 row g12 app-sav',
      role: 'region',
      'aria-label': 'Blaze mobilalkalmazás',
    },
    h(
      'div',
      { class: 'col g4 grow' },
      h('span', { style: { fontWeight: '600', fontSize: '14px' }, text: 'Mobilon kényelmesebb' }),
      h('span', {
        class: 'caption ts',
        text: 'Töltsd le a Blaze appot, és a feladataid mindig nálad vannak.',
      }),
    ),
    h('a', {
      class: 'btn btn-primary btn-sm',
      href: cel.url,
      target: '_blank',
      rel: 'noopener',
      text: 'Letöltés',
    }),
    h('button', {
      class: 'btn btn-ghost btn-sm app-sav-bezar',
      type: 'button',
      'aria-label': 'Bezárás',
      text: '×',
      onClick: () => {
        rememberDismissal(Date.now(), storage);
        burkolat.remove();
      },
    }),
  );

  // A tokeneket a `.app` osztály hordozza (lásd a süti-sávot).
  burkolat = h(
    'div',
    { class: `app app-sav-burkolat${gyoker?.classList.contains('dark') ? ' dark' : ''}` },
    doboz,
  );
  document.body.appendChild(burkolat);
}
